import clsx from 'clsx';
import { formatRelativeForDateDivider } from '../../Message';

interface VirtualMessageThreadDateDividerProps {
  date: Date;
  className?: string;
}

export function VirtualMessageThreadDateDivider({ date, className }: VirtualMessageThreadDateDividerProps) {
  return (
    <div className={clsx(className, 'px-3 m-auto')}>
      <div
        className={clsx(
          'mt-4 z-[1] flex h-8 w-full m-auto flex-col justify-center border-b border-b-darkMode-gray-medium/40'
        )}
      >
        <p className="date-divider-text text-sm w-full font-medium capitalize leading-[16px] text-darkMode-gray-light max-w-[1048px] m-auto">
          {formatRelativeForDateDivider(date)}
        </p>
      </div>
    </div>
  );
}
